import { AUTORI, DISCIPLINE, SLUG, TEMI } from 'utils/endpoint'
import React from 'react'
import { api } from 'utils'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import Error from 'next/error'
import MetaSeo from 'components/atomic/MetaSeo'
import BoxAutori from 'components/BoxAutori'
import { useRouter } from 'next/router'
import BoxRisorse from 'components/BoxRisorse'
import BoxTemaDelMomento from 'components/BoxTemaDelMomento'
import BoxTagCloud from 'components/BoxTagCloud'
import { Actions } from 'react-components/organisms'

const DisciplinaDetail = React.memo(
  ({ disciplina, pagina, statusCode, autori, risorseSponsorizzate }) => {
    if (!disciplina) return <Error statusCode={statusCode} />

    const router = useRouter()

    const defaultColor = '000'
    const color = `#${disciplina.color || defaultColor}`

    const urlRisorse = `${router.asPath.split('?')[0]}/risorse?filtri_id=${
      disciplina.valore_attributo
    }`

    const urlAutori = `/autori?filtri_id=${disciplina.valore_attributo}`

    return (
      <>
        {disciplina ? (
          <>
            <MetaSeo seo={pagina.seo} />

            <main className="hub-page" style={{ backgroundColor: color }}>
              <div className="w-container">
                <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
              </div>

              <section className="hub-page__header u-before-section">
                <div className="w-container">
                  <h1 className="hub-page__header__title">{disciplina.titolo}</h1>
                </div>
              </section>

              <section className="hub-page__content u-bg-white">
                {disciplina.tag_cloud.length ? (
                  <BoxTagCloud
                    title={`Esplora le materie ${disciplina.titolo}`}
                    description={`Qui trovi gli argomenti più cercati dalla community di Giunti Scuola. Trova quello che fa per te e prepara la tua prossima lezione. ${disciplina.titolo}`}
                    tags={disciplina.tag_cloud.map((tag) => ({ nome: tag.titolo, ...tag }))}
                    baseHref={urlRisorse}
                  />
                ) : null}
                {disciplina.tema_del_momento && (
                  <BoxTemaDelMomento
                    tema={disciplina.tema_del_momento}
                    variant="blue"
                    items={risorseSponsorizzate}
                  />
                )}
                {autori.length ? <BoxAutori autori={autori} href={urlAutori} /> : null}
                <BoxRisorse href={urlRisorse} />
                <div className="w-container">
                  <Actions item={disciplina} labelGTM="tema" share />
                </div>
              </section>
            </main>
          </>
        ) : null}
      </>
    )
  }
)

export async function getStaticPaths() {
  const response = await api.get(DISCIPLINE)
  const discipline = response.data

  const paths = discipline
    .map((d) => ({
      params: { slug: d.slug },
    }))
    .slice(0, 1)

  return {
    paths,
    fallback: 'blocking',
  }
}

export const getStaticProps = async ({ params: { slug } }) => {
  try {
    const response = await api.get(`${DISCIPLINE}${SLUG}${slug}/`)
    const disciplina = response.data

    const pagina = disciplina.pagina

    const toolbarProps = { toolbarItem: disciplina, toolbarPage: pagina }
    const params = {
      attributi__valore_attributo_id: disciplina.valore_attributo,
      limit: 4,
      relevance: 1,
    }
    const autoriResponse = await api.get(AUTORI, { params })
    const autori = autoriResponse.data || []

    let risorseSponsorizzate = null
    if (disciplina.tema_del_momento) {
      const risorseSponsorizzateResponse = await api.get(
        `${TEMI}${disciplina.tema_del_momento.id}/risorse_sponsorizzate/`,
        {
          params: { limit: 3 },
        }
      )
      risorseSponsorizzate = risorseSponsorizzateResponse.data.risorse
    }

    return {
      props: {
        disciplina,
        pagina,
        key: disciplina.id,
        ...toolbarProps,
        autori,
        risorseSponsorizzate,
      },
      revalidate: 60 * 2,
    }
  } catch (error) {
    console.log(error)
    return {
      notFound: true,
    }
  }
}

export default DisciplinaDetail
